module.exports = __webpack_public_path__ + "img/91.8242d517.png";